import React from "react";
import "./Loader.css";
import { useData } from "../../context/DataContext/DataProvider";
import { getCategoryPalette } from "../../util/categoryPalette";
const Loader = ({
  white = false,
  width = 18,
  height = 10,
  color = "black",
}) => {
  const data = useData();

  const categories = getCategoryPalette(data?.globalConfig?.categories);

  return (
    <div
      className="dot-loader-1"
      style={{
        "--color": white ? "white" : color,
        "--size": `${height}px`,
      }}
    >
      {categories?.slice(0, 6)?.map((category, index) => (
        <span
          key={index}
          style={{
            "--color": category.activeColor,
          }}
        ></span>
      ))}
    </div>
  );
};

export default Loader;
